module.exports = __webpack_public_path__ + "img/P29.9ed62217.png";